module.exports = __webpack_public_path__ + "static/media/Luxury-Bag-Repair.a483e991.png";